import {
  BrowseDataJsonLd,
  BrowsePageMeta,
  CardsSlider,
  useDeepLinkOpener,
} from '@aboutyou/logic-components';
import {useHydrationDone} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {HomePage as HomePageLegacy} from '../../../../bridge/pages/home/Home';
import {LegacyDesktopStyles} from '../../../../bridge/styles/LegacyBaseStyles';

export const HomePage = () => {
  const isHydrationDone = useHydrationDone();
  useDeepLinkOpener();

  return (
    <>
      <div className={LegacyDesktopStyles} />
      <BrowsePageMeta />
      <BrowseDataJsonLd />
      <StyledCardsSlider />
      {isHydrationDone && (
        <>
          <HomePageLegacy />
        </>
      )}
    </>
  );
};

const StyledCardsSlider = styled(CardsSlider)`
  margin-bottom: 60px;
`;
